var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01447a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m584.64 81.41c-10.559 0-19.125 8.5625-19.125 19.125v231.77c0 11.836-9.6133 21.438-21.438 21.438-11.859 0-21.461-9.6133-21.461-21.438v-231.77c0-11.645-9.4375-21.094-21.094-21.094-11.66 0-21.105 9.4492-21.105 21.094v231.77c0 11.836-9.6016 21.438-21.438 21.438-11.848 0-21.449-9.6133-21.449-21.438v-231.77c0-11.645-9.4492-21.094-21.094-21.094-11.66 0-21.105 9.4492-21.105 21.094v231.77c0 11.836-9.5859 21.438-21.449 21.438-11.848 0-21.449-9.6133-21.449-21.438v-231.77c0-10.559-8.5625-19.125-19.125-19.125-10.547 0-19.113 8.5625-19.113 19.125v293.94c0 67.125 45.75 123.42 107.72 139.8l-30.633 543.88c0 23.418 48.633 42.402 67.68 42.402s67.68-18.984 67.68-42.402l-30.633-543.88c61.984-16.383 107.72-72.684 107.72-139.8l0.003906-293.94c0-10.559-8.5273-19.125-19.098-19.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853.23 81.473c-29.559 0-56.25 11.898-79.34 35.383-113.38 115.3-110.12 506.58-109.38 550.8l0.53125 32.047h155.58v388.27c0 17.988 14.59 32.578 32.59 32.578s32.59-14.59 32.59-32.578l-0.003907-973.91c0-18.012-14.574-32.59-32.574-32.59z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.33b42e86ee2265f51c629c72069e4d1a.svg";
export { ForwardRef as ReactComponent };